import { COLUMN_ID_MERGED_COLUMN } from '@atlassian/jira-issue-table-common/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	COLUMN_ID_CHECKBOX,
	COLUMN_ID_EXPAND_BUTTON,
	EXPAND_CELL_PADDING,
} from '../../constants.tsx';
import type { Column } from '../../types.tsx';

const calculateStickyOffsets = (orderedStickyColumns: Column[], nonStickyColumns: Column[]) => {
	let cumulativeStickyOffset = 0;
	const processedStickyColumns = orderedStickyColumns.map((column, i) => {
		const { id, customWidth, defaultWidth } = column;
		const stickyOffsets = cumulativeStickyOffset;
		if (id === COLUMN_ID_EXPAND_BUTTON) {
			cumulativeStickyOffset += defaultWidth + EXPAND_CELL_PADDING;
		} else {
			cumulativeStickyOffset += customWidth ?? defaultWidth;
		}
		const isLastStickyColumn =
			id === COLUMN_ID_MERGED_COLUMN
				? column.mergedColumns &&
					column.mergedColumns.length > 0 &&
					i === orderedStickyColumns.length - 1
				: i === orderedStickyColumns.length - 1;

		return {
			...column,
			isColumnSticky: true,
			stickyOffsets,
			isLastStickyColumn,
		};
	});
	return [...processedStickyColumns, ...nonStickyColumns];
};

export const getColumnsWithStickyOffsets = (columnConfig: Column[], stickyColumnIds?: string[]) => {
	const stickyColumnsById: {
		[key: string]: Column;
	} = {};
	const orderedStickyColumns: Column[] = [];
	const nonStickyColumns: Column[] = [];

	// if there are no sticky columns we don't calculate offsets and set any columns to sticky
	// this avoids a bug where checkbox is rendered as sticky before the stickyColumnIds are populated
	// due to concurrent rendering
	if (stickyColumnIds && stickyColumnIds.length === 0 && fg('jira_list_frozen_column_bugfix')) {
		return columnConfig;
	}

	columnConfig.forEach((column) => {
		const { id } = column;
		if (id === COLUMN_ID_CHECKBOX || id === COLUMN_ID_EXPAND_BUTTON) {
			orderedStickyColumns.push(column);
		} else if (id === COLUMN_ID_MERGED_COLUMN) {
			const { mergedColumns = [] } = column;
			const isMergedCellSticky = mergedColumns.some((mergedCol) =>
				stickyColumnIds?.includes(mergedCol.id),
			);
			if (isMergedCellSticky) {
				orderedStickyColumns.push(column);
			} else {
				nonStickyColumns.push(column);
			}
		} else if (stickyColumnIds?.includes(id)) {
			stickyColumnsById[id] = column;
		} else {
			nonStickyColumns.push(column);
		}
	});

	stickyColumnIds?.forEach((columnId) => {
		if (stickyColumnsById[columnId]) {
			orderedStickyColumns.push(stickyColumnsById[columnId]);
		}
	});
	return calculateStickyOffsets(orderedStickyColumns, nonStickyColumns);
};
